import styled from 'styled-components';

export const Container = styled.tr`
  td {
    padding: 5px 0;
    font-size: ${({ theme }) => theme.fonts.size.normal};
    font-weight: ${({ theme }) => theme.fonts.weight.thin};
  }
`;

export const ButtonDownload = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black};
  border: ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  padding: 2px;
  transition: all 200ms ease-in-out;
  :hover {
    background-color: ${({ theme }) => theme.colors.black};
    border-color: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }
`;
